module.exports = __webpack_public_path__ + "static/media/mercedes_logo.ae1a2e47.svg";